const Forms =
    [
        {
            type: 'multipleSelect',
            options: 'CatStatus',
            label: 'status',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'Status',
            id: 'Status',
            id2: 'Status',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatTransportMode',
            label: 'transport_mode',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'TransportMode',
            id2: 'TransportMode',
            id: 'TransportMode',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        // {
        //     type: 'multipleSelect',
        //     options: 'CatShipmentType',
        //     label: 'shipment_type',
        //     id2: 'ShipmentType',
        //     class: 'col-md-3 col-lg-3 col-sm-12',
        //     name: 'ShipmentType',
        //     id: 'ShipmentType',
        //     datatype: 'select',
        //     show: true,
        //     style: { fontSize: '11px', fontWeight: 'bold' },
        //     value: "",
        //     values: []
        // },
        // {
        //     type: 'multipleSelect',
        //     options: 'CatIncotermCode',
        //     label: 'incoterm',
        //     id2: 'IncotermCode',
        //     class: 'col-md-3 col-lg-3 col-sm-12',
        //     name: 'IncotermCode',
        //     id: 'IncotermCode',
        //     datatype: 'select',
        //     show: true,
        //     style: { fontSize: '11px', fontWeight: 'bold' },
        //     value: "",
        //     values: []
        // },
        {
            type: 'multipleSelect',
            options: 'CatCustomerName',
            label: 'customer',
            id2: 'CustomerName',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'CustomerName',
            id: 'CustomerName',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatShipperName',
            label: 'shipper',
            id2: 'ShipperName',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'ShipperName',
            id: 'ShipperName',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatConsigneeName',
            label: 'consignee',
            id2: 'ConsigneeName',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'ConsigneeName',
            id: 'ConsigneeName',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatPOL',
            label: 'origin',
            id2: 'POL',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'POL',
            id: 'POL',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatPOD',
            label: 'destination',
            id2: 'POD',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'POD',
            id: 'POD',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        // {
        //     type: 'multipleSelect',
        //     options: 'CatCarrier',
        //     label: 'carrier',
        //     id2: 'Carrier',
        //     class: 'col-md-3 col-lg-3 col-sm-12',
        //     name: 'Carrier',
        //     id: 'Carrier',
        //     datatype: 'select',
        //     show: true,
        //     style: { fontSize: '11px', fontWeight: 'bold' },
        //     value: "",
        //     values: []
        // },
        {
            type: 'Datetime',
            label: 'etd',
            name: 'ETDList',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'ETDList',
            id2: 'ETDList',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        },
        {
            type: 'Datetime',
            label: 'eta',
            name: 'ETAList',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'ETAList',
            id2: 'ETAList',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        },
        {
            type: 'Datetime',
            label: 'atd',
            name: 'ATD',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'ATD',
            id2: 'ATD',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        },
        {
            type: 'Datetime',
            label: 'ata',
            name: 'ATA',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'ATA',
            id2: 'ATA',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        }
    ]

export default Forms